import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AgricolaPaymentErrorDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-agricola-payment-error-dialog',
  templateUrl: './agricola-payment-error-dialog.component.html',
  styleUrls: ['./agricola-payment-error-dialog.component.css'],
  standalone: false
})
export class AgricolaPaymentErrorDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: AgricolaPaymentErrorDialogData,
    private readonly dialogRef: MatDialogRef<AgricolaPaymentErrorDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
